import { render } from "./SavedSearches.vue?vue&type=template&id=4653a84e&scoped=true"
import script from "./SavedSearches.vue?vue&type=script&lang=js"
export * from "./SavedSearches.vue?vue&type=script&lang=js"

import "./SavedSearches.vue?vue&type=style&index=0&id=4653a84e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4653a84e"]])

export default __exports__